import i18n from '../i18n';
import { DemoFan } from '../datas/demoFan';
import { GenerationResponse } from '../services/generationsApi';
import { Album, Playlist } from '../types';
import { OidcUser } from '../types/oidcUser';
import { getOrganizationId } from './getOrganization';

interface BuildGenerationPlaylistParams {
  songVersion: 1 | 2;
  activeMusicGeneration: GenerationResponse;
  fanData?: DemoFan;
  fanSlug: string;
  user: OidcUser | undefined;
  savedSongCreationId1: React.MutableRefObject<string | null>;
  savedSongCreationId2: React.MutableRefObject<string | null>;
}

export const buildGenerationPlaylist = ({
  songVersion,
  activeMusicGeneration,
  fanData,
  fanSlug,
  user,
  savedSongCreationId1,
  savedSongCreationId2,
}: BuildGenerationPlaylistParams): Playlist => {
  const tracks = [];
  const TEMP_ID_PREFIX = 'temp-generated-';
  const track1Id =
    savedSongCreationId1.current ||
    `${TEMP_ID_PREFIX}${activeMusicGeneration.taskId}-1`;
  const track2Id =
    savedSongCreationId2.current ||
    `${TEMP_ID_PREFIX}${activeMusicGeneration.taskId}-2`;
  const selectedTrackId = songVersion === 1 ? track1Id : track2Id;

  if (activeMusicGeneration.songUrl1) {
    tracks.push({
      id: track1Id,
      name: activeMusicGeneration.title1 || 'Version 1',
      url: activeMusicGeneration.songUrl1,
      duration: activeMusicGeneration.duration1 || 0,
      lyrics: activeMusicGeneration.lyrics1,
      lyricsTimestamped: activeMusicGeneration.lyricsTimestamped1,
    });
  }

  if (activeMusicGeneration.songUrl2) {
    tracks.push({
      id: track2Id,
      name: activeMusicGeneration.title2 || 'Version 2',
      url: activeMusicGeneration.songUrl2,
      duration: activeMusicGeneration.duration2 || 0,
      lyrics: activeMusicGeneration.lyrics2,
      lyricsTimestamped: activeMusicGeneration.lyricsTimestamped2,
    });
  }

  const albumArt =
    songVersion === 1
      ? activeMusicGeneration.thumbnailUrl1 ||
        activeMusicGeneration.musicGptCoverUrl ||
        ''
      : activeMusicGeneration.thumbnailUrl2 ||
        activeMusicGeneration.musicGptCoverUrl ||
        '';

  const orgId = getOrganizationId(user as OidcUser);
  const album: Album = {
    id: activeMusicGeneration.taskId,
    upc: 'generated',
    pk: '',
    albumName: activeMusicGeneration.title1 || i18n.t('generation.generatedSong'),
    albumArtUrl: albumArt,
    description: activeMusicGeneration.prompt,
    category: 'generated',
    genre: [activeMusicGeneration.musicStyle || 'Pop'],
    tracks,
    contributors: [
      {
        id: fanData?.id || fanSlug,
        givenName:
          fanData?.given_name || fanData?.artist_alias || 'AI Generated',
        thumbnailUrl:
          (songVersion === 1
            ? activeMusicGeneration.thumbnailUrl1
            : activeMusicGeneration.thumbnailUrl2) ||
          fanData?.image_url ||
          '',
        videoDesktopUrl: '',
        videoMobileUrl: '',
      },
    ],
    likes: 0,
    type: 'album',
    isLiked: false,
    orgId,
  };

  const currentIndex = Math.max(
    tracks.findIndex((track) => track.id === selectedTrackId),
    0,
  );

  const playlist: Playlist = {
    currentIndex,
    album,
  };

  return playlist;
};
